import { useEffect } from 'react'
import { useLocation } from 'react-router'

interface Props {
  children?: any
}

let lastPathName = ''

function ScrollToTop(props: Props) {
  const location = useLocation()
  useEffect(() => {
    const elem = document.getElementById('core-layout')
    if (
      elem &&
      elem.scrollTo &&
      typeof elem.scrollTo === 'function' &&
      location.pathname !== lastPathName
    ) {
      elem.scrollTo(0, 0)
      lastPathName = location.pathname
    }
  }, [location])
  return props.children
}

export default ScrollToTop
